(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["niche-gift-cart-coordinator"] && !Shopify.designMode) return;
  try {
    (() => {
    let active = false;
    let restoreCart = false;
    let continueShopping = false;
    let scheduled = false;
    let watchedOverlay = null;
    let watchedDrawer = null;
    let closingCart = Promise.resolve();
    const visibleGift = () => {
      const gift = document.querySelector('#docapp-gift-choice-modal-wrapper.docapp-visible');
      return gift && gift.getClientRects().length ? gift : null;
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(sync);
    };
    const overlayObserver = new MutationObserver(schedule);
    const drawerObserver = new MutationObserver(schedule);
    const sync = () => {
      scheduled = false;
      const gift = visibleGift();
      const wrapper = document.querySelector('#docapp-gift-choice-modal-wrapper');
      const overlay = wrapper?.closest('.docapp-overlay-modal');
      const drawer = document.getElementById('cart-drawer');
      if (overlay !== watchedOverlay) {
        overlayObserver.disconnect();
        watchedOverlay = overlay;
        if (overlay) overlayObserver.observe(overlay, { attributes: true, attributeFilter: ['class', 'style', 'hidden'], childList: true, subtree: true });
      }
      if (drawer !== watchedDrawer) {
        drawerObserver.disconnect();
        watchedDrawer = drawer;
        if (drawer) drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['open'] });
      }
      if (gift) {
        if (!active) {
          active = true;
          restoreCart = false;
          continueShopping = false;
        }
        if (drawer?.hasAttribute('open') && typeof drawer.hide === 'function') {
          restoreCart = true;
          closingCart = drawer.hide();
          closingCart.then(() => {
            const currentGift = visibleGift();
            if (currentGift && !currentGift.contains(document.activeElement)) {
              currentGift.querySelector('button:not([disabled])')?.focus({ preventScroll: true });
            }
          });
        }
      } else if (active) {
        active = false;
        const shouldRestore = restoreCart && !continueShopping;
        restoreCart = false;
        if (shouldRestore) {
          closingCart.then(() => {
            const currentDrawer = document.getElementById('cart-drawer');
            if (!visibleGift() && typeof currentDrawer?.show === 'function') currentDrawer.show();
          });
        }
      }
    };
    document.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('.docapp-gift-choice-modal-done-button, .docapp-gift-choice-modal-cart-button')) continueShopping = true;
    }, true);
    document.addEventListener('focusin', event => {
      const gift = visibleGift();
      if (active && gift && !gift.contains(event.target) && !document.getElementById('cart-drawer')?.hasAttribute('open')) {
        gift.querySelector('button:not([disabled])')?.focus({ preventScroll: true });
      }
    });
    document.addEventListener('keydown', event => {
      const gift = visibleGift();
      if (!active || !gift || event.key !== 'Tab') return;
      const controls = Array.from(gift.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex="0"]')).filter(element => element.getClientRects().length);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (!first) return;
      if (!gift.contains(document.activeElement) || (!event.shiftKey && document.activeElement === last)) {
        event.preventDefault();
        first.focus();
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      }
    });
    new MutationObserver(schedule).observe(document.body, { childList: true });
    sync();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["niche-restock-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('niche-restock-dialog')) {
    class NicheRestockDialog extends HTMLElement {
      static async register({shop, productId, variantId, email, locale, marketId}) {
        const intent = {shopify_product_id: Number(productId), shopify_variant_id: Number(variantId), channel: 'email', quantity: 1, source: 'api'};
        if (marketId) intent.shopify_market_id = Number(marketId);
        const response = await fetch('https://app.stoqapp.com/api/v1/intents.json', {
          method: 'POST',
          credentials: 'omit',
          headers: {'Content-Type': 'application/json', 'X-Shopify-Shop-Domain': shop},
          body: JSON.stringify({intent, customer: {email: email.trim(), locale, accepts_marketing: false}})
        });
        const result = await response.json();
        const saved = result.intents?.find(item => String(item.shopify_variant_id) === String(variantId) && item.id);
        if (!response.ok || result.errors?.length || !saved) throw new Error('Restock signup was not confirmed');
        return saved.optin_confirmed !== false;
      }

      connectedCallback() {
        this.abort = new AbortController();
        const options = {signal: this.abort.signal};
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.status = this.querySelector('[data-restock-status]');
        this.submit = this.querySelector('[type="submit"]');
        this.submitLabel = this.submit.textContent;
        document.addEventListener('click', event => {
          const trigger = event.target.closest('[data-niche-restock]');
          if (!trigger || this.busy) return;
          event.preventDefault();
          this.open(trigger);
        }, options);
        this.querySelector('[data-restock-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('niche-restock-open');
          this.trigger?.focus({preventScroll: true});
        }, options);
        this.form.addEventListener('submit', event => this.send(event), options);
        this.reveal = () => document.querySelectorAll('[data-niche-restock][hidden]').forEach(button => { button.hidden = false; });
        this.reveal();
        this.observer = new MutationObserver(this.reveal);
        this.observer.observe(document.querySelector('main'), {childList: true, subtree: true});
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        document.documentElement.classList.remove('niche-restock-open');
      }

      open(trigger) {
        const variants = JSON.parse(trigger.dataset.variants).filter(variant => !variant.available);
        if (!variants.length) return;
        this.trigger = trigger;
        this.productId = trigger.dataset.productId;
        this.form.reset();
        this.form.hidden = false;
        this.status.textContent = '';
        this.status.removeAttribute('data-error');
        this.querySelector('[data-restock-product]').textContent = trigger.dataset.productTitle;
        const select = this.form.elements.variant;
        select.replaceChildren(...variants.map(variant => new Option(variant.title, String(variant.id))));
        select.value = trigger.dataset.variantId;
        if (!select.value) select.selectedIndex = 0;
        this.querySelector('[data-restock-variant-field]').hidden = variants.length === 1 && variants[0].title === 'Default Title';
        this.dialog.showModal();
        document.documentElement.classList.add('niche-restock-open');
        this.form.elements.email.focus({preventScroll: true});
      }

      async send(event) {
        event.preventDefault();
        if (this.busy || !this.form.reportValidity()) return;
        this.busy = true;
        this.submit.disabled = true;
        this.submit.textContent = this.dataset.submitting;
        this.status.textContent = '';
        this.status.removeAttribute('data-error');
        try {
          const confirmed = await NicheRestockDialog.register({shop: this.dataset.shop, productId: this.productId, variantId: this.form.elements.variant.value, email: this.form.elements.email.value, locale: this.dataset.locale, marketId: this.dataset.marketId});
          this.form.hidden = true;
          this.status.textContent = confirmed ? this.dataset.success : this.dataset.confirm;
          this.form.elements.email.value = '';
        } catch {
          this.status.textContent = this.dataset.error;
          this.status.setAttribute('data-error', '');
        } finally {
          this.busy = false;
          this.submit.disabled = false;
          this.submit.textContent = this.submitLabel;
          if (this.dialog.open) this.status.focus();
        }
      }
    }
    customElements.define('niche-restock-dialog', NicheRestockDialog);
  }
  } catch(e) { console.error(e); }
})();

})();
